import { render } from "./ReservationResult.vue?vue&type=template&id=5803642c&scoped=true"
import script from "./ReservationResult.vue?vue&type=script&lang=js"
export * from "./ReservationResult.vue?vue&type=script&lang=js"

import "./ReservationResult.vue?vue&type=style&index=0&id=5803642c&lang=scss&scoped=true"

import exportComponent from "/home/douglas/Documents/Rwi/surefooted-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5803642c"]])

export default __exports__